import React from "react";
import { useTranslation } from "react-i18next";
import { MotionDiv, StaggerGrid, StaggerItem } from "../../utils/animations";
import fondoVideosIa from "../../assets/images/site/fondo-videos-ia.webp";

const VIDEOS_IA = [
    {"id": "GufxtG-crYg", "url": "https://www.youtube.com/watch?v=GufxtG-crYg"},
    {"id": "Hr7XpeGm9sI", "url": "https://www.youtube.com/watch?v=Hr7XpeGm9sI"},
    {"id": "Lh8HLTkfvhU", "url": "https://www.youtube.com/watch?v=Lh8HLTkfvhU"},
    {"id": "Mk0xwyeeoCQ", "url": "https://www.youtube.com/watch?v=Mk0xwyeeoCQ"},
    {"id": "xlHw-LVeKy8", "url": "https://www.youtube.com/watch?v=xlHw-LVeKy8"},
    {"id": "9b4rma52mN4", "url": "https://www.youtube.com/watch?v=9b4rma52mN4"},
];

function ProductFeaturesSection() {
    const { t } = useTranslation();
    return (
        <section id="videos-ia" className="relative py-24 bg-em-bgsoft overflow-hidden">
            {/* Background ambient glow to keep the premium feel */}
            <div className="absolute top-0 inset-x-0 w-full h-full bg-gradient-to-b from-em-bg to-em-bgsoft z-0 pointer-events-none"></div>
            <div className="section-bg section-bg--videos-ia" aria-hidden="true">
                <img src={fondoVideosIa} alt="" className="section-bg-img" loading="lazy" decoding="async" />
            </div>
            <div className="absolute -top-40 -left-60 w-[500px] h-[500px] bg-em-vivid/10 rounded-full blur-[120px] pointer-events-none"></div>
            <div className="absolute bottom-10 right-0 w-[400px] h-[400px] bg-em-accent2/5 rounded-full blur-[100px] pointer-events-none"></div>

            <div className="section-container relative z-10">
                {/* Header */}
                <MotionDiv className="section-header">
                    <div className="section-tag">{t("productFeatures.tag")}</div>
                    <h2 className="section-title">{t("productFeatures.title")}</h2>
                    <p className="section-subtitle">
                        {t("productFeatures.subtitle")}
                    </p>
                </MotionDiv>

                {/* Videos Grid */}
                <StaggerGrid className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 max-w-[1400px] mx-auto">
                    {VIDEOS_IA.map((v, index) => (
                        <StaggerItem key={v.id}>
                        <div 
                            className="group flex flex-col bg-em-card border border-em-text/10 rounded-2xl overflow-hidden hover:border-em-vivid/40 transition-all duration-300 hover:shadow-[0_20px_50px_-15px_rgb(var(--em-vivid-rgb)_/_0.2)] hover:-translate-y-2"
                        >
                            {/* Proporción 16:9 fija para IFrames */}
                            <div className="relative w-full pb-[56.25%] bg-black">
                                <iframe
                                    src={`https://www.youtube.com/embed/${v.id}?rel=0`}
                                    title={t("productFeatures.videoTitle", { n: index + 1 })}
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    referrerPolicy="strict-origin-when-cross-origin"
                                    allowFullScreen
                                    loading="lazy"
                                    className="absolute top-0 left-0 w-full h-full border-0"
                                ></iframe>
                            </div>
                            
                            {/* Footer / Acción de la tarjeta */}
                            <div className="px-5 py-4 flex justify-between items-center bg-em-bg/80 backdrop-blur-sm border-t border-em-text/10">
                                <span className="text-em-muted text-sm font-medium">{t("productFeatures.concept", { n: index + 1 })}</span>
                                <a
                                    href={v.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-sm font-bold text-em-accent flex items-center gap-2 hover:text-em-accent2 transition-colors"
                                >
                                    {t("productFeatures.watchOnYoutube")}
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1">
                                        <path fillRule="evenodd" d="M5.22 14.78a.75.75 0 001.06 0l7.22-7.22v5.69a.75.75 0 001.5 0v-7.5a.75.75 0 00-.75-.75h-7.5a.75.75 0 000 1.5h5.69l-7.22 7.22a.75.75 0 000 1.06z" clipRule="evenodd" />
                                    </svg>
                                </a>
                            </div>
                        </div>
                        </StaggerItem>
                    ))}
                </StaggerGrid>
            </div>
        </section>
    );
}

export default ProductFeaturesSection;
